import axios from "axios";
import { store } from "../stores/store";
import { showNotification } from "../slices/AlertMessageSlice";
import { checkTokenExpiry, getToken } from "../token/token";
import getHeaders from "../domain/DomainHeader";
import Cookies from "js-cookie";

const DEFAULT_TENANT =
  process.env.NEXT_PUBLIC_DEFAULT_TENANT_ID || "superadmin";

function getTenantHeaders() {
  // ✅ Server/build time (no window)
  if (typeof window === "undefined") {
    return {
      "Content-Type": "application/json",
      "X-Tenant-Id": DEFAULT_TENANT,
    };
  }

  // ✅ Browser time
  const subdomain = window.location.hostname.split(".")[0];
  const customTenant = Cookies.get("custom_tenant");
  const hideTenantId = [""];

  if (customTenant) {
    return {
      "Content-Type": "application/json",
      "X-Tenant-Id": customTenant,
    };
  }

  if (subdomain === "www" || subdomain === "localhost") {
    return {
      "Content-Type": "application/json",
      // You can choose to include default tenant even on localhost if your API requires it:
      "X-Tenant-Id": DEFAULT_TENANT,
    };
  }

  return {
    "Content-Type": "application/json",
    ...(!hideTenantId.includes(window.location.pathname) && {
      "X-Tenant-Id": subdomain,
    }),
  };
}

const API = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Tenant-Id": DEFAULT_TENANT, // safe default
  },
});

API.interceptors.request.use(
  async (config) => {
    console.log("api config", config);
    // ✅ Check token expiry
    checkTokenExpiry();

    // ✅ Always ensure tenant header exists (server+browser)
    config.headers = {
      ...(config.headers || {}),
      ...getTenantHeaders(),
    };

    // ✅ Additional domain headers (browser only)
    if (typeof window !== "undefined") {
      const extra = await getHeaders(window.location.hostname);
      config.headers = {
        ...(config.headers || {}),
        ...extra,
      };
    }

    // ✅ Token (browser only usually)
    // const token = getToken("token");
    const token = typeof window !== "undefined" ? getToken("token") : null;
    if (token) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: "Bearer " + token,
      };
    }

    return config;
  },
  (error) => {
    console.log("Error in api request", error);
    Promise.reject(error);
  },
);

// Response interceptor unchanged (keep window guard)

API.interceptors.response.use(
  (response) => {
    console.log("api response", response);
    if (typeof window !== "undefined") {
      if (
        response.data.success &&
        (response.config.method === "post" ||
          response.config.method === "put" ||
          response.config.method === "delete")
      ) {
        if (response?.config?.url === "/cart") {
          store.dispatch(
            showNotification({
              messageToaster: true,
              toasterType: "success",
              toasterMessage: response?.data?.message || "Success!",
              action: true,
              actionPath: "/cart",
              actionLeble: "go to cart",
            }),
          );
        } else {
          store.dispatch(
            showNotification({
              messageToaster: true,
              toasterType: "success",
              toasterMessage: response?.data?.message || "Success!",
            }),
          );
        }
      }
    }
    return response;
  },
  (error) => {
    console.log("Error in api response", error);
    if (typeof window !== "undefined") {
      if (error?.name === "AxiosError") {
        // store.dispatch(
        //   showNotification({
        //     messageToaster: true,
        //     toasterType: "error",
        //     toasterMessage:
        //       error?.message || "Your session is expired! Please login",
        //   }),
        // );
      }
      if (
        !error?.response?.data?.success &&
        (error.config?.method === "post" ||
          error.config?.method === "put" ||
          error.config?.method === "delete")
      ) {
        // store.dispatch(
        //   showNotification({
        //     messageToaster: true,
        //     toasterType: "error",
        //     toasterMessage:
        //       error?.response?.data?.message ||
        //       error?.response?.data?.error ||
        //       "Something went wrong! Please check your internet connection.",
        //   }),
        // );
      } else if (error?.response?.data?.error === "Unauthorized") {
        // store.dispatch(
        //   showNotification({
        //     messageToaster: true,
        //     toasterType: "error",
        //     toasterMessage: "Your session is expired! Please login",
        //     action: true,
        //     actionPath: "/user/login",
        //     actionLeble: "Login",
        //   }),
        // );
      }
    }
    return Promise.reject(error);
  },
);

export default API;
